export const homeicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="17"
    viewBox="0 0 21 17"
    fill="none"
  >
    <path
      d="M10.7391 0.13958C10.6199 0.0491242 10.4732 0 10.3222 0C10.1712 0 10.0245 0.0491242 9.90538 0.13958L0.259766 7.46608L1.09411 8.49394L2.27346 7.59816V15.6923C2.27417 16.0389 2.41584 16.3711 2.66745 16.6162C2.91905 16.8613 3.2601 16.9993 3.61593 17H17.0406C17.3964 16.9993 17.7375 16.8613 17.9891 16.6162C18.2407 16.3711 18.3823 16.0389 18.3831 15.6923V7.60404L19.5624 8.49983L20.3968 7.47196L10.7391 0.13958ZM11.6707 15.6923H8.98579V10.4614H11.6707V15.6923ZM13.0132 15.6923V10.4614C13.0132 10.1146 12.8718 9.78195 12.62 9.53671C12.3682 9.29146 12.0268 9.15369 11.6707 9.15369H8.98579C8.62975 9.15369 8.28829 9.29146 8.03653 9.53671C7.78477 9.78195 7.64333 10.1146 7.64333 10.4614V15.6923H3.61593V6.57879L10.3283 1.48522L17.0406 6.58533V15.6923H13.0132Z"
      fill="black"
    />
  </svg>
);
export const signinicon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M12.0333 8.6L8.23333 12.7167M12.0333 8.6L8.23333 4.8M12.0333 8.6H0M7.6 1H15.8333V16.2H7.6"
      stroke="black"
    />
  </svg>
);
export const tasks = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <g clip-path="url(#clip0_787_6432)">
      <path
        d="M17.8996 20.7778H4.10066C3.96423 20.7786 3.82898 20.7525 3.70263 20.7011C3.57628 20.6496 3.4613 20.5737 3.36426 20.4778C3.26723 20.3819 3.19003 20.2679 3.13708 20.1421C3.08413 20.0164 3.05646 19.8814 3.05566 19.745V4.08835C3.05929 3.93717 3.09494 3.78849 3.16025 3.6521C3.22556 3.51572 3.31905 3.39474 3.43455 3.29714C3.55005 3.19954 3.68494 3.12754 3.83031 3.0859C3.97568 3.04426 4.12823 3.03392 4.27789 3.05557H5.50011V4.27779H4.27789V19.5556H17.7223V4.27779H16.5001V3.05557H17.8751C18.0136 3.05149 18.1515 3.07515 18.2806 3.12515C18.4098 3.17514 18.5277 3.25047 18.6274 3.3467C18.727 3.44293 18.8064 3.55812 18.8609 3.68548C18.9153 3.81285 18.9438 3.94982 18.9446 4.08835V19.745C18.9438 19.8814 18.9161 20.0164 18.8631 20.1421C18.8102 20.2679 18.733 20.3819 18.636 20.4778C18.5389 20.5737 18.4239 20.6496 18.2976 20.7011C18.1712 20.7525 18.036 20.7786 17.8996 20.7778Z"
        fill="black"
      />
      <path
        d="M10.1811 15.7422L6.9055 12.4666C6.80615 12.349 6.75486 12.1983 6.76186 12.0445C6.76887 11.8907 6.83367 11.7452 6.9433 11.6371C7.05293 11.529 7.19931 11.4663 7.35319 11.4615C7.50706 11.4567 7.65709 11.5101 7.77328 11.6111L10.1811 14.0189L15.4611 8.73887C15.578 8.63875 15.7283 8.58643 15.8821 8.59237C16.0359 8.59832 16.1818 8.66207 16.2907 8.77091C16.3995 8.87975 16.4633 9.02564 16.4692 9.17944C16.4752 9.33325 16.4228 9.48363 16.3227 9.60053L10.1811 15.7422Z"
        fill="black"
      />
      <path
        d="M15.8889 6.7222H6.11108V4.47942C6.11269 4.10228 6.26322 3.74104 6.52991 3.47436C6.79659 3.20768 7.15783 3.05714 7.53497 3.05553H8.62886C8.76349 2.52972 9.06929 2.06368 9.49805 1.73087C9.92681 1.39805 10.4541 1.21741 10.9969 1.21741C11.5397 1.21741 12.067 1.39805 12.4958 1.73087C12.9245 2.06368 13.2303 2.52972 13.365 3.05553H14.4589C14.8371 3.05553 15.1999 3.20535 15.4679 3.47221C15.7359 3.73906 15.8872 4.10122 15.8889 4.47942V6.7222ZM7.33331 5.49998H14.6666V4.47942C14.6666 4.42594 14.6454 4.37464 14.6076 4.33682C14.5698 4.299 14.5185 4.27776 14.465 4.27776H12.2222V3.66664C12.2222 3.34249 12.0934 3.03161 11.8642 2.8024C11.635 2.57319 11.3241 2.44442 11 2.44442C10.6758 2.44442 10.3649 2.57319 10.1357 2.8024C9.90652 3.03161 9.77775 3.34249 9.77775 3.66664V4.27776H7.53497C7.50849 4.27776 7.48227 4.28297 7.4578 4.29311C7.43333 4.30324 7.4111 4.3181 7.39237 4.33682C7.37365 4.35555 7.35879 4.37778 7.34866 4.40225C7.33852 4.42672 7.33331 4.45294 7.33331 4.47942V5.49998Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_787_6432">
        <path d="M0 0H22V14C22 18.4183 18.4183 22 14 22H0V0Z" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const filteroutlined = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 26 27"
    fill="none"
  >
    <path
      d="M23.4574 1H2.54025C2.2444 0.999743 1.95475 1.08607 1.70598 1.24866C1.45721 1.41124 1.25987 1.64318 1.13759 1.91671C1.01532 2.19023 0.973285 2.49375 1.01653 2.7909C1.05978 3.08806 1.18647 3.36626 1.38144 3.59219L9.54087 13.0578C9.78627 13.3429 9.92135 13.7088 9.92098 14.0875V21.7031C9.92098 21.8244 9.9488 21.944 10.0022 22.0525C10.0556 22.161 10.1332 22.2554 10.2288 22.3281L14.8456 25.8437C14.9599 25.9308 15.0958 25.9838 15.2382 25.9968C15.3805 26.0099 15.5236 25.9824 15.6514 25.9175C15.7792 25.8526 15.8867 25.7529 15.9618 25.6295C16.0369 25.5061 16.0767 25.3638 16.0767 25.2187V14.0875C16.0764 13.7088 16.2114 13.3429 16.4568 13.0578L24.6163 3.59063C25.4873 2.58125 24.7794 1 23.4574 1Z"
      stroke="#1D2951"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
);

export const NavArrowIcon = (
  <svg
    width="29"
    height="28"
    viewBox="0 0 29 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="28.5"
      y="28"
      width="28"
      height="28"
      rx="8.75"
      transform="rotate(180 28.5 28)"
      fill="#E17954"
    />
    <path
      d="M16.25 10.5L12.75 14L16.25 17.5"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LogoutIcon = (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.80189 0.5H9.17689V8.75H7.80189V0.5ZM5.73939 0.972656V2.47656C4.50762 2.99219 3.50501 3.82292 2.73158 4.96875C1.98679 6.11458 1.61439 7.375 1.61439 8.75C1.61439 10.6406 2.28757 12.2591 3.63392 13.6055C4.98027 14.9518 6.59876 15.625 8.48939 15.625C10.38 15.625 11.9985 14.9518 13.3449 13.6055C14.6912 12.2591 15.3644 10.6406 15.3644 8.75C15.3644 7.375 14.9777 6.11458 14.2042 4.96875C13.4594 3.82292 12.4712 2.99219 11.2394 2.47656V0.972656C12.8722 1.54557 14.1899 2.54818 15.1925 3.98047C16.2238 5.38411 16.7394 6.97396 16.7394 8.75C16.7394 11.013 15.923 12.9609 14.2902 14.5938C12.686 16.1979 10.7524 17 8.48939 17C6.22637 17 4.27845 16.1979 2.64564 14.5938C1.04147 12.9609 0.239389 11.013 0.239389 8.75C0.239389 6.97396 0.740692 5.38411 1.7433 3.98047C2.77455 2.54818 4.10658 1.54557 5.73939 0.972656Z"
      fill="#202224"
    />
  </svg>
);

export const homeIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.75 16.5V10.5C11.75 10.3011 11.671 10.1103 11.5303 9.96967C11.3897 9.82902 11.1989 9.75 11 9.75H8C7.80109 9.75 7.61032 9.82902 7.46967 9.96967C7.32902 10.1103 7.25 10.3011 7.25 10.5V16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.75 8.2501C2.74995 8.0319 2.7975 7.81632 2.88934 7.61839C2.98118 7.42046 3.1151 7.24495 3.28175 7.1041L8.53175 2.60485C8.80249 2.37603 9.14552 2.25049 9.5 2.25049C9.85448 2.25049 10.1975 2.37603 10.4683 2.60485L15.7183 7.1041C15.8849 7.24495 16.0188 7.42046 16.1107 7.61839C16.2025 7.81632 16.2501 8.0319 16.25 8.2501V15.0001C16.25 15.3979 16.092 15.7795 15.8107 16.0608C15.5294 16.3421 15.1478 16.5001 14.75 16.5001H4.25C3.85218 16.5001 3.47064 16.3421 3.18934 16.0608C2.90804 15.7795 2.75 15.3979 2.75 15.0001V8.2501Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const signInIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 5.5L10.2567 9.79525C10.0279 9.92816 9.768 9.99817 9.50338 9.99817C9.23875 9.99817 8.97883 9.92816 8.75 9.79525L2 5.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.5 3.25H3.5C2.67157 3.25 2 3.92157 2 4.75V13.75C2 14.5784 2.67157 15.25 3.5 15.25H15.5C16.3284 15.25 17 14.5784 17 13.75V4.75C17 3.92157 16.3284 3.25 15.5 3.25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const communicationIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.874 13.176C11.0289 13.2471 11.2034 13.2634 11.3688 13.2221C11.5341 13.1808 11.6805 13.0844 11.7838 12.9487L12.05 12.6C12.1897 12.4137 12.3709 12.2625 12.5792 12.1584C12.7875 12.0542 13.0171 12 13.25 12H15.5C15.8978 12 16.2794 12.158 16.5607 12.4393C16.842 12.7206 17 13.1022 17 13.5V15.75C17 16.1478 16.842 16.5294 16.5607 16.8107C16.2794 17.092 15.8978 17.25 15.5 17.25C11.9196 17.25 8.4858 15.8277 5.95406 13.2959C3.42232 10.7642 2 7.33042 2 3.75C2 3.35218 2.15804 2.97064 2.43934 2.68934C2.72064 2.40804 3.10218 2.25 3.5 2.25H5.75C6.14782 2.25 6.52936 2.40804 6.81066 2.68934C7.09196 2.97064 7.25 3.35218 7.25 3.75V6C7.25 6.23287 7.19578 6.46254 7.09164 6.67082C6.9875 6.8791 6.83629 7.06028 6.65 7.2L6.299 7.46325C6.16131 7.56838 6.06426 7.71794 6.02434 7.88651C5.98442 8.05509 6.00409 8.23228 6.08 8.388C7.10501 10.4699 8.79082 12.1536 10.874 13.176Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const attendanceIcon = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7561_11151)">
      <path
        d="M17 4.5C17.5523 4.5 18 4.94772 18 5.5V17C18 17.5523 17.5523 18 17 18H1C0.447716 18 0 17.5523 0 17V5.5C0 4.94772 0.447715 4.5 1 4.5H4.54395C4.53223 4.40625 4.52344 4.3125 4.51758 4.21875C4.51172 4.125 4.50586 4.03125 4.5 3.9375C4.5 3.39258 4.60254 2.88281 4.80762 2.4082C5.0127 1.93359 5.29395 1.51465 5.65137 1.15137C6.00879 0.788086 6.4248 0.506836 6.89941 0.307617C7.37402 0.108398 7.88672 0.00585938 8.4375 0C8.98242 0 9.49219 0.102539 9.9668 0.307617C10.4414 0.512695 10.8604 0.793945 11.2236 1.15137C11.5869 1.50879 11.8682 1.9248 12.0674 2.39941C12.2666 2.87402 12.3691 3.38672 12.375 3.9375C12.375 4.03125 12.3721 4.125 12.3662 4.21875C12.3604 4.3125 12.3486 4.40625 12.3311 4.5H17ZM8.4375 1.125C8.05078 1.125 7.6875 1.19824 7.34766 1.34473C7.00781 1.49121 6.70898 1.69336 6.45117 1.95117C6.19336 2.20898 5.99121 2.50781 5.84473 2.84766C5.69824 3.1875 5.625 3.55078 5.625 3.9375C5.625 4.32422 5.69824 4.6875 5.84473 5.02734C5.99121 5.36719 6.19043 5.66602 6.44238 5.92383C6.69434 6.18164 6.99316 6.38379 7.33887 6.53027C7.68457 6.67676 8.05078 6.75 8.4375 6.75C8.82422 6.75 9.1875 6.67676 9.52734 6.53027C9.86719 6.38379 10.1631 6.18457 10.415 5.93262C10.667 5.68066 10.8691 5.38184 11.0215 5.03613C11.1738 4.69043 11.25 4.32422 11.25 3.9375C11.25 3.55078 11.1768 3.1875 11.0303 2.84766C10.8838 2.50781 10.6816 2.21191 10.4238 1.95996C10.166 1.70801 9.86719 1.50586 9.52734 1.35352C9.1875 1.20117 8.82422 1.125 8.4375 1.125ZM16.875 5.625H11.9971C11.8506 5.92969 11.6689 6.21387 11.4521 6.47754C11.2354 6.74121 10.9863 6.9668 10.7051 7.1543C11.3086 7.38867 11.8535 7.69922 12.3398 8.08594C12.8262 8.47266 13.2363 8.91797 13.5703 9.42188C13.9043 9.92578 14.165 10.4766 14.3525 11.0742C14.54 11.6719 14.6309 12.293 14.625 12.9375V13.5H13.5V12.9375C13.5 12.2168 13.3711 11.5488 13.1133 10.9336C12.8555 10.3184 12.501 9.78223 12.0498 9.3252C11.5986 8.86816 11.0654 8.51367 10.4502 8.26172C9.83496 8.00977 9.16406 7.88086 8.4375 7.875C7.78711 7.875 7.17188 7.98633 6.5918 8.20898C6.01172 8.43164 5.49609 8.74512 5.04492 9.14941C4.59375 9.55371 4.22461 10.0283 3.9375 10.5732C3.65039 11.1182 3.47168 11.7188 3.40137 12.375H9.09668L7.0752 10.3535L7.875 9.5625L11.25 12.9375L7.875 16.3125L7.0752 15.5215L9.09668 13.5H2.25V12.9375C2.25 12.293 2.34082 11.6748 2.52246 11.083C2.7041 10.4912 2.96777 9.94336 3.31348 9.43945C3.65918 8.93555 4.07227 8.49023 4.55273 8.10352C5.0332 7.7168 5.5752 7.40332 6.17871 7.16309C5.60449 6.75879 5.1709 6.24609 4.87793 5.625H1.125V16.875H16.875V5.625Z"
        fill="CurrentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7561_11151">
        <rect width="18" height="18" fill="CurrentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const onboardIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7374_7668)">
      <path
        d="M17.5 4.75C18.0523 4.75 18.5 5.19772 18.5 5.75V17.25C18.5 17.8023 18.0523 18.25 17.5 18.25H1.5C0.947716 18.25 0.5 17.8023 0.5 17.25V5.75C0.5 5.19772 0.947715 4.75 1.5 4.75H5.04395C5.03223 4.65625 5.02344 4.5625 5.01758 4.46875C5.01172 4.375 5.00586 4.28125 5 4.1875C5 3.64258 5.10254 3.13281 5.30762 2.6582C5.5127 2.18359 5.79395 1.76465 6.15137 1.40137C6.50879 1.03809 6.9248 0.756836 7.39941 0.557617C7.87402 0.358398 8.38672 0.255859 8.9375 0.25C9.48242 0.25 9.99219 0.352539 10.4668 0.557617C10.9414 0.762695 11.3604 1.04395 11.7236 1.40137C12.0869 1.75879 12.3682 2.1748 12.5674 2.64941C12.7666 3.12402 12.8691 3.63672 12.875 4.1875C12.875 4.28125 12.8721 4.375 12.8662 4.46875C12.8604 4.5625 12.8486 4.65625 12.8311 4.75H17.5ZM8.9375 1.375C8.55078 1.375 8.1875 1.44824 7.84766 1.59473C7.50781 1.74121 7.20898 1.94336 6.95117 2.20117C6.69336 2.45898 6.49121 2.75781 6.34473 3.09766C6.19824 3.4375 6.125 3.80078 6.125 4.1875C6.125 4.57422 6.19824 4.9375 6.34473 5.27734C6.49121 5.61719 6.69043 5.91602 6.94238 6.17383C7.19434 6.43164 7.49316 6.63379 7.83887 6.78027C8.18457 6.92676 8.55078 7 8.9375 7C9.32422 7 9.6875 6.92676 10.0273 6.78027C10.3672 6.63379 10.6631 6.43457 10.915 6.18262C11.167 5.93066 11.3691 5.63184 11.5215 5.28613C11.6738 4.94043 11.75 4.57422 11.75 4.1875C11.75 3.80078 11.6768 3.4375 11.5303 3.09766C11.3838 2.75781 11.1816 2.46191 10.9238 2.20996C10.666 1.95801 10.3672 1.75586 10.0273 1.60352C9.6875 1.45117 9.32422 1.375 8.9375 1.375ZM17.375 5.875H12.4971C12.3506 6.17969 12.1689 6.46387 11.9521 6.72754C11.7354 6.99121 11.4863 7.2168 11.2051 7.4043C11.8086 7.63867 12.3535 7.94922 12.8398 8.33594C13.3262 8.72266 13.7363 9.16797 14.0703 9.67188C14.4043 10.1758 14.665 10.7266 14.8525 11.3242C15.04 11.9219 15.1309 12.543 15.125 13.1875V13.75H14V13.1875C14 12.4668 13.8711 11.7988 13.6133 11.1836C13.3555 10.5684 13.001 10.0322 12.5498 9.5752C12.0986 9.11816 11.5654 8.76367 10.9502 8.51172C10.335 8.25977 9.66406 8.13086 8.9375 8.125C8.28711 8.125 7.67188 8.23633 7.0918 8.45898C6.51172 8.68164 5.99609 8.99512 5.54492 9.39941C5.09375 9.80371 4.72461 10.2783 4.4375 10.8232C4.15039 11.3682 3.97168 11.9688 3.90137 12.625H9.59668L7.5752 10.6035L8.375 9.8125L11.75 13.1875L8.375 16.5625L7.5752 15.7715L9.59668 13.75H2.75V13.1875C2.75 12.543 2.84082 11.9248 3.02246 11.333C3.2041 10.7412 3.46777 10.1934 3.81348 9.68945C4.15918 9.18555 4.57227 8.74023 5.05273 8.35352C5.5332 7.9668 6.0752 7.65332 6.67871 7.41309C6.10449 7.00879 5.6709 6.49609 5.37793 5.875H1.625V17.125H17.375V5.875Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7374_7668">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const patientIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.50005 8.25C11.1575 8.25 12.5 6.9075 12.5 5.25C12.5 3.5925 11.1575 2.25 9.50005 2.25C7.84255 2.25 6.50005 3.5925 6.50005 5.25C6.50005 6.9075 7.84255 8.25 9.50005 8.25ZM9.50005 3.75C10.325 3.75 11 4.425 11 5.25C11 6.075 10.325 6.75 9.50005 6.75C8.67505 6.75 8.00005 6.075 8.00005 5.25C8.00005 4.425 8.67505 3.75 9.50005 3.75ZM14.2925 10.17C13.0325 9.525 11.3975 9 9.50005 9C7.60255 9 5.96755 9.525 4.70755 10.17C4.34159 10.3585 4.03502 10.6447 3.82187 10.9969C3.60872 11.349 3.49733 11.7534 3.50005 12.165V17.25H5.00005V12.165C5.00005 11.88 5.15005 11.625 5.37505 11.505C6.28255 11.0475 7.72255 10.5 9.50005 10.5C10.07 10.5 10.6025 10.5525 11.0975 10.65L9.93505 13.125H7.81255C6.67255 13.125 5.75005 14.0475 5.75005 15.1875C5.75005 16.3275 6.67255 17.25 7.81255 17.25H14C14.825 17.25 15.5 16.575 15.5 15.75V12.165C15.5 11.325 15.0425 10.5525 14.2925 10.17ZM8.70505 15.75H7.81255C7.50505 15.75 7.25005 15.495 7.25005 15.1875C7.25005 14.88 7.50505 14.625 7.81255 14.625H9.23005L8.70505 15.75ZM14 15.75H10.3625L12.5675 11.0475C12.9725 11.1975 13.325 11.355 13.625 11.505C13.85 11.625 14 11.88 14 12.165V15.75Z"
      fill="currentColor"
    />
  </svg>
);

export const RPMIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5 2.5H3.5C2.67157 2.5 2 3.17157 2 4V11.5C2 12.3284 2.67157 13 3.5 13H15.5C16.3284 13 17 12.3284 17 11.5V4C17 3.17157 16.3284 2.5 15.5 2.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 16H12.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5 13V16"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const userIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 17.25C13.6421 17.25 17 13.8921 17 9.75C17 5.60786 13.6421 2.25 9.5 2.25C5.35786 2.25 2 5.60786 2 9.75C2 13.8921 5.35786 17.25 9.5 17.25Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.5 10.5C10.7426 10.5 11.75 9.49264 11.75 8.25C11.75 7.00736 10.7426 6 9.5 6C8.25736 6 7.25 7.00736 7.25 8.25C7.25 9.49264 8.25736 10.5 9.5 10.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.75 16.2465V15C5.75 14.6022 5.90804 14.2206 6.18934 13.9393C6.47064 13.658 6.85218 13.5 7.25 13.5H11.75C12.1478 13.5 12.5294 13.658 12.8107 13.9393C13.092 14.2206 13.25 14.6022 13.25 15V16.2465"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const waitingRoom = (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.4999 13.52C11.7193 13.52 11.9023 13.4433 12.0489 13.29C12.1956 13.1367 12.2689 12.9567 12.2689 12.75C12.2689 12.5307 12.1956 12.3477 12.0489 12.201C11.9023 12.0543 11.7193 11.981 11.4999 11.981C11.2933 11.981 11.1133 12.0543 10.9599 12.201C10.8066 12.3477 10.7299 12.5307 10.7299 12.75C10.7299 12.9567 10.8066 13.1367 10.9599 13.29C11.1133 13.4433 11.2933 13.52 11.4999 13.52ZM7.49994 20.75V19.75L14.4999 19.058V5.86L8.11594 5.25V4.25L15.4999 4.973V19.939L7.49994 20.75ZM4.96094 20.75V19.75H6.49994V4.25H18.4999V19.75H20.0389V20.75H4.96094ZM7.49994 19.75H17.4999V5.25H7.49994V19.75Z"
      fill="currentColor"
    />
  </svg>
);
export const onboard = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
  >
    <path
      d="M6.00005 6C7.65755 6 9.00005 4.6575 9.00005 3C9.00005 1.3425 7.65755 0 6.00005 0C4.34255 0 3.00005 1.3425 3.00005 3C3.00005 4.6575 4.34255 6 6.00005 6ZM6.00005 1.5C6.82505 1.5 7.50005 2.175 7.50005 3C7.50005 3.825 6.82505 4.5 6.00005 4.5C5.17505 4.5 4.50005 3.825 4.50005 3C4.50005 2.175 5.17505 1.5 6.00005 1.5ZM10.7925 7.92C9.53255 7.275 7.89755 6.75 6.00005 6.75C4.10255 6.75 2.46755 7.275 1.20755 7.92C0.841593 8.10849 0.535025 8.3947 0.321873 8.74686C0.108722 9.09902 -0.00267402 9.50336 4.87427e-05 9.915V15H1.50005V9.915C1.50005 9.63 1.65005 9.375 1.87505 9.255C2.78255 8.7975 4.22255 8.25 6.00005 8.25C6.57005 8.25 7.10255 8.3025 7.59755 8.4L6.43505 10.875H4.31255C3.17255 10.875 2.25005 11.7975 2.25005 12.9375C2.25005 14.0775 3.17255 15 4.31255 15H10.5C11.325 15 12 14.325 12 13.5V9.915C12 9.075 11.5425 8.3025 10.7925 7.92ZM5.20505 13.5H4.31255C4.00505 13.5 3.75005 13.245 3.75005 12.9375C3.75005 12.63 4.00505 12.375 4.31255 12.375H5.73005L5.20505 13.5ZM10.5 13.5H6.86255L9.06755 8.7975C9.47255 8.9475 9.82505 9.105 10.125 9.255C10.35 9.375 10.5 9.63 10.5 9.915V13.5Z"
      fill="currentColor"
    />
  </svg>
);
export const Reports = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 3V15C2.75 15.3978 2.90804 15.7794 3.18934 16.0607C3.47064 16.342 3.85218 16.5 4.25 16.5H16.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 13.5V7.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.25 13.5V4.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.5 13.5V11.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const taskIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7374_7698)">
      <path
        d="M15.145 17.2502H3.855C3.74338 17.2509 3.63272 17.2295 3.52934 17.1874C3.42596 17.1453 3.33188 17.0833 3.25249 17.0048C3.1731 16.9263 3.10993 16.833 3.06661 16.7301C3.02329 16.6272 3.00065 16.5168 3 16.4052V3.59522C3.00297 3.47154 3.03213 3.34988 3.08557 3.2383C3.139 3.12671 3.2155 3.02772 3.31 2.94787C3.4045 2.86801 3.51486 2.80911 3.6338 2.77504C3.75274 2.74097 3.87755 2.73251 4 2.75022H5V3.75022H4V16.2502H15V3.75022H14V2.75022H15.125C15.2383 2.74689 15.3511 2.76624 15.4568 2.80715C15.5625 2.84806 15.659 2.90969 15.7405 2.98842C15.822 3.06716 15.887 3.1614 15.9315 3.26561C15.9761 3.36982 15.9994 3.48188 16 3.59522V16.4052C15.9993 16.5168 15.9767 16.6272 15.9334 16.7301C15.8901 16.833 15.8269 16.9263 15.7475 17.0048C15.6681 17.0833 15.574 17.1453 15.4707 17.1874C15.3673 17.2295 15.2566 17.2509 15.145 17.2502Z"
        fill="currentColor"
      />
      <path
        d="M8.83026 13.13L6.15026 10.45C6.06898 10.3538 6.02701 10.2304 6.03275 10.1046C6.03848 9.97877 6.09149 9.85974 6.18119 9.77131C6.27089 9.68288 6.39066 9.63156 6.51655 9.62761C6.64245 9.62366 6.7652 9.66737 6.86026 9.75001L8.83026 11.72L13.1503 7.40001C13.2459 7.3181 13.369 7.2753 13.4948 7.28016C13.6206 7.28502 13.74 7.33719 13.829 7.42623C13.9181 7.51528 13.9703 7.63465 13.9751 7.76049C13.98 7.88633 13.9372 8.00936 13.8553 8.10501L8.83026 13.13Z"
        fill="currentColor"
      />
      <path
        d="M13.5 5.75002H5.5V3.91502C5.50132 3.60644 5.62448 3.31089 5.84267 3.09269C6.06087 2.87449 6.35643 2.75133 6.665 2.75002H7.56C7.67015 2.31981 7.92035 1.9385 8.27116 1.6662C8.62196 1.39389 9.05342 1.24609 9.4975 1.24609C9.94159 1.24609 10.373 1.39389 10.7238 1.6662C11.0746 1.9385 11.3249 2.31981 11.435 2.75002H12.33C12.6394 2.75001 12.9363 2.87259 13.1556 3.09093C13.3748 3.30927 13.4987 3.60558 13.5 3.91502V5.75002ZM6.5 4.75002H12.5V3.91502C12.5 3.87125 12.4826 3.82929 12.4517 3.79834C12.4207 3.7674 12.3788 3.75002 12.335 3.75002H10.5V3.25002C10.5 2.9848 10.3946 2.73044 10.2071 2.54291C10.0196 2.35537 9.76522 2.25002 9.5 2.25002C9.23478 2.25002 8.98043 2.35537 8.79289 2.54291C8.60536 2.73044 8.5 2.9848 8.5 3.25002V3.75002H6.665C6.64333 3.75002 6.62188 3.75428 6.60186 3.76258C6.58184 3.77087 6.56365 3.78302 6.54833 3.79834C6.53301 3.81366 6.52085 3.83185 6.51256 3.85187C6.50427 3.87189 6.5 3.89335 6.5 3.91502V4.75002Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7374_7698">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const schedulerIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 9.75C2 6.92175 2 5.50725 2.879 4.629C3.758 3.75075 5.17175 3.75 8 3.75H11C13.8282 3.75 15.2427 3.75 16.121 4.629C16.9992 5.508 17 6.92175 17 9.75V11.25C17 14.0782 17 15.4927 16.121 16.371C15.242 17.2492 13.8282 17.25 11 17.25H8C5.17175 17.25 3.75725 17.25 2.879 16.371C2.00075 15.492 2 14.0782 2 11.25V9.75Z"
      stroke="currentColor"
      stroke-width="1.5"
    />
    <path
      d="M5.75 3.75V2.625M13.25 3.75V2.625M2.375 7.5H16.625"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M14 13.5C14 13.6989 13.921 13.8897 13.7803 14.0303C13.6397 14.171 13.4489 14.25 13.25 14.25C13.0511 14.25 12.8603 14.171 12.7197 14.0303C12.579 13.8897 12.5 13.6989 12.5 13.5C12.5 13.3011 12.579 13.1103 12.7197 12.9697C12.8603 12.829 13.0511 12.75 13.25 12.75C13.4489 12.75 13.6397 12.829 13.7803 12.9697C13.921 13.1103 14 13.3011 14 13.5ZM14 10.5C14 10.6989 13.921 10.8897 13.7803 11.0303C13.6397 11.171 13.4489 11.25 13.25 11.25C13.0511 11.25 12.8603 11.171 12.7197 11.0303C12.579 10.8897 12.5 10.6989 12.5 10.5C12.5 10.3011 12.579 10.1103 12.7197 9.96967C12.8603 9.82902 13.0511 9.75 13.25 9.75C13.4489 9.75 13.6397 9.82902 13.7803 9.96967C13.921 10.1103 14 10.3011 14 10.5ZM10.25 13.5C10.25 13.6989 10.171 13.8897 10.0303 14.0303C9.88968 14.171 9.69891 14.25 9.5 14.25C9.30109 14.25 9.11032 14.171 8.96967 14.0303C8.82902 13.8897 8.75 13.6989 8.75 13.5C8.75 13.3011 8.82902 13.1103 8.96967 12.9697C9.11032 12.829 9.30109 12.75 9.5 12.75C9.69891 12.75 9.88968 12.829 10.0303 12.9697C10.171 13.1103 10.25 13.3011 10.25 13.5ZM10.25 10.5C10.25 10.6989 10.171 10.8897 10.0303 11.0303C9.88968 11.171 9.69891 11.25 9.5 11.25C9.30109 11.25 9.11032 11.171 8.96967 11.0303C8.82902 10.8897 8.75 10.6989 8.75 10.5C8.75 10.3011 8.82902 10.1103 8.96967 9.96967C9.11032 9.82902 9.30109 9.75 9.5 9.75C9.69891 9.75 9.88968 9.82902 10.0303 9.96967C10.171 10.1103 10.25 10.3011 10.25 10.5ZM6.5 13.5C6.5 13.6989 6.42098 13.8897 6.28033 14.0303C6.13968 14.171 5.94891 14.25 5.75 14.25C5.55109 14.25 5.36032 14.171 5.21967 14.0303C5.07902 13.8897 5 13.6989 5 13.5C5 13.3011 5.07902 13.1103 5.21967 12.9697C5.36032 12.829 5.55109 12.75 5.75 12.75C5.94891 12.75 6.13968 12.829 6.28033 12.9697C6.42098 13.1103 6.5 13.3011 6.5 13.5ZM6.5 10.5C6.5 10.6989 6.42098 10.8897 6.28033 11.0303C6.13968 11.171 5.94891 11.25 5.75 11.25C5.55109 11.25 5.36032 11.171 5.21967 11.0303C5.07902 10.8897 5 10.6989 5 10.5C5 10.3011 5.07902 10.1103 5.21967 9.96967C5.36032 9.82902 5.55109 9.75 5.75 9.75C5.94891 9.75 6.13968 9.82902 6.28033 9.96967C6.42098 10.1103 6.5 10.3011 6.5 10.5Z"
      fill="currentColor"
    />
  </svg>
);

export const InventoryIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7374_7706)">
      <path
        d="M16.25 5.5V14.2C16.25 15.1975 15.4475 16 14.45 16H4.55C3.5525 16 2.75 15.1975 2.75 14.2V5.5M6.5 8.5H12.5M2.45 2.5H16.55C16.8683 2.5 17.1735 2.62643 17.3985 2.85147C17.6236 3.07652 17.75 3.38174 17.75 3.7V4.3C17.75 4.45759 17.719 4.61363 17.6587 4.75922C17.5984 4.90481 17.51 5.0371 17.3985 5.14853C17.2871 5.25996 17.1548 5.34835 17.0092 5.40866C16.8636 5.46896 16.7076 5.5 16.55 5.5H2.45C2.13174 5.5 1.82652 5.37357 1.60147 5.14853C1.37643 4.92348 1.25 4.61826 1.25 4.3V3.7C1.25 3.54241 1.28104 3.38637 1.34134 3.24078C1.40165 3.09519 1.49004 2.9629 1.60147 2.85147C1.82652 2.62643 2.13174 2.5 2.45 2.5Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7374_7706">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5 0.25)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const careIqIcon = (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7374_7711)">
      <path
        d="M1.84475 6.0885C1.9235 5.28863 2.471 4.6455 3.26412 4.515C4.38237 4.3305 6.33875 4.125 9.5 4.125C12.6613 4.125 14.6176 4.3305 15.7363 4.515C16.529 4.6455 17.0769 5.28863 17.1553 6.0885C17.2588 7.13737 17.375 8.78475 17.375 10.875C17.375 12.9652 17.2588 14.6126 17.1553 15.6615C17.0765 16.4614 16.529 17.1045 15.7359 17.235C14.6176 17.4195 12.6613 17.625 9.5 17.625C6.33875 17.625 4.38275 17.4195 3.26375 17.235C2.471 17.1045 1.92312 16.4614 1.84475 15.6615C1.74125 14.6126 1.625 12.9652 1.625 10.875C1.625 8.78475 1.74125 7.13737 1.84475 6.0885Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.77675 4.18278C6.94813 3.65515 7.241 3.03903 7.46075 2.60703C7.64 2.25453 7.96325 2.00103 8.35475 1.94853C8.73444 1.89863 9.11704 1.87407 9.5 1.87503C9.96688 1.87503 10.3542 1.90915 10.6449 1.94853C11.0364 2.00103 11.3596 2.2549 11.5389 2.60703C11.7586 3.03865 12.0515 3.65515 12.2229 4.18278M8.045 13.8668C8.05775 14.2227 8.28425 14.5249 8.63712 14.5725C8.85537 14.6022 9.14075 14.625 9.5 14.625C9.85925 14.625 10.1446 14.6022 10.3629 14.5725C10.7154 14.5249 10.9423 14.2227 10.9554 13.8668C10.9678 13.5274 10.9816 13.0324 10.9906 12.3657C11.6574 12.3567 12.1524 12.3428 12.4918 12.3304C12.8476 12.3173 13.1499 12.0904 13.1975 11.7379C13.2271 11.5197 13.25 11.2343 13.25 10.875C13.25 10.5158 13.2271 10.2304 13.1975 10.0122C13.1499 9.65965 12.8476 9.43278 12.4918 9.41965C12.1524 9.40728 11.6574 9.3934 10.9906 9.3844C10.9846 8.88391 10.9728 8.3835 10.9554 7.88328C10.9423 7.5274 10.7154 7.22515 10.3629 7.17753C10.0768 7.14052 9.78848 7.12298 9.5 7.12503C9.14075 7.12503 8.85537 7.1479 8.63712 7.17753C8.28462 7.22515 8.05775 7.5274 8.04462 7.88328C8.03225 8.22265 8.01837 8.71765 8.00937 9.3844C7.34262 9.3934 6.84762 9.40728 6.50825 9.41965C6.15237 9.43278 5.85013 9.65965 5.8025 10.0122C5.77288 10.2304 5.75 10.5158 5.75 10.875C5.75 11.2343 5.77288 11.5197 5.8025 11.7379C5.85013 12.0904 6.15237 12.3173 6.50825 12.3304C6.84762 12.3428 7.34262 12.3567 8.00937 12.3657C8.01837 13.0324 8.03225 13.5274 8.04462 13.8668H8.045Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7374_7711">
        <rect
          width="18"
          height="18"
          fill="white"
          transform="translate(0.5 0.75)"
        />
      </clipPath>
    </defs>
  </svg>
);
